export var RemoteConfigErrorCodes = /*#__PURE__*/ function(RemoteConfigErrorCodes) {
    RemoteConfigErrorCodes["Default"] = "NA";
    RemoteConfigErrorCodes["MalformedUri"] = "CFG01000";
    RemoteConfigErrorCodes["HttpBadResponse"] = "CFG02";
    RemoteConfigErrorCodes["SuccessfulEmptyResponse"] = "CFG04";
    RemoteConfigErrorCodes["RequestInProgress"] = "CFG06000";
    RemoteConfigErrorCodes["ParsingFailed"] = "CFG03";
    RemoteConfigErrorCodes["RequestTimedOut"] = "CFG05000";
    return RemoteConfigErrorCodes;
}({});
export var MatcherType = /*#__PURE__*/ function(MatcherType) {
    MatcherType["String"] = "String";
    MatcherType["Number"] = "Number";
    MatcherType["Version"] = "Version";
    return MatcherType;
}({});

//# sourceMappingURL=core-video-config.enums.js.map